import { auth } from '../firebase';
import logger from './logger';
import { onAuthStateChanged } from 'firebase/auth';


let isInitialized = false;
let currentNavigate = null;

/**
 * Initialize the global Firebase error listener
 * @param {Function} navigate - React Router navigate function
 */
export const initializeFirebaseErrorListener = (navigate) => {
  if (isInitialized) {
    logger.warn('Firebase error listener already initialized');
    return;
  }

  currentNavigate = navigate;
  isInitialized = true;
  logger.debug('Firebase error listener navigation handler set', {
    hasNavigate: !!currentNavigate
  });

  // Listen for authentication state changes and handle errors
  onAuthStateChanged(
    auth,
    (user) => {
      // User signed in or signed out
      logger.debug('Auth state changed:', user ? 'signed in' : 'signed out');
    },
    (error) => {
      logger.error('Auth state change error:', error);
      // Don't call handleGlobalFirebaseError to avoid infinite loop
    }
  );

  logger.debug('Firebase error listener initialized (minimal mode)');
};

/**
 * Handle global Firebase errors (disabled to prevent infinite loop)
 * @param {Error} error - The Firebase error
 */





/**
 * Set up global error handlers for Firebase operations (disabled)
 */





/**
 * Redirect to unauthorized page
 */








/**
 * Redirect to login page
 */








/**
 * Update the navigate function (useful when the component re-renders)
 * @param {Function} navigate - React Router navigate function
 */
export const updateNavigate = (navigate) => {
  currentNavigate = navigate;
};

/**
 * Clean up the error listener
 */
export const cleanupFirebaseErrorListener = () => {
  isInitialized = false;
  currentNavigate = null;
  logger.debug('Firebase error listener cleaned up');
};
